import type { SxProps, Theme } from '@mui/material/styles';

import { signupPageStyles } from '../../../pages/signup/SignupPage/SignupPage.styles';
import { signupResultLayoutStyles } from '../SignupResultLayout/SignupResultLayout.styles';

export const signupCreateAccountStyles = {
  input: signupPageStyles.input,
  consentError: signupPageStyles.consentError,
  emailButton: signupPageStyles.emailButton,
  resultMessage: signupResultLayoutStyles.resultMessage,
  completionForm: (): SxProps<Theme> => ({
    display: 'grid',
    gap: 2,
    mt: 4,
  }),
};
